/* eslint-disable @typescript-eslint/camelcase */
import {
  DUTY_TAX_CONFIGURATION_DEFAULT_SORT_BY,
  DutyTaxConfigurationListFilter,
  DutyTaxResolveParams
} from "@/domain/entities/DutyTaxConfiguration";

export class DutyTaxConfigurationListRequest {
  page = 1;
  limit = 20;
  destination_country_code = "";
  status = "";
  search = "";
  sort_by: string = DUTY_TAX_CONFIGURATION_DEFAULT_SORT_BY;
  sort_dir = "asc";

  constructor(fields?: Partial<DutyTaxConfigurationListRequest>) {
    Object.assign(this, fields);
  }

  static fromFilter(
    filter: DutyTaxConfigurationListFilter
  ): DutyTaxConfigurationListRequest {
    return new DutyTaxConfigurationListRequest({
      page: filter.page ?? 1,
      limit: filter.limit ?? 20,
      destination_country_code: filter.destinationCountryCode ?? "",
      status: filter.status ?? "",
      search: filter.search ?? "",
      sort_by: filter.sortBy || DUTY_TAX_CONFIGURATION_DEFAULT_SORT_BY,
      sort_dir: filter.sortDir || "asc"
    });
  }

  toQueryString(): string {
    const params = new URLSearchParams();
    const entries: [string, string | number][] = [
      ["page", this.page],
      ["limit", this.limit],
      ["destination_country_code", this.destination_country_code],
      ["status", this.status],
      ["search", this.search],
      ["sort_by", this.sort_by],
      ["sort_dir", this.sort_dir]
    ];
    entries.forEach(([key, value]) => {
      if (value !== "" && value !== undefined && value !== null) {
        params.set(key, String(value));
      }
    });
    return params.toString();
  }
}

export class DutyTaxResolveApiRequest {
  private destination_country_code: string;
  private chargeable_weight_kg: number;
  private origin_currency: string;
  private items: {
    commodity_code: string;
    summed_price: number;
    first_input_index: number;
  }[];

  constructor(params: DutyTaxResolveParams) {
    this.destination_country_code = params.destinationCountryCode;
    this.chargeable_weight_kg =
      Math.round(params.chargeableWeightKg * 100) / 100;
    this.origin_currency = params.originCurrency;
    this.items = params.items.map((item) => ({
      commodity_code: item.commodityCode,
      summed_price: item.summedPrice,
      first_input_index: item.firstInputIndex
    }));
  }

  public toJSON(): string {
    return JSON.stringify({
      destination_country_code: this.destination_country_code,
      chargeable_weight_kg: this.chargeable_weight_kg,
      origin_currency: this.origin_currency,
      items: this.items
    });
  }
}
